module.exports = __webpack_public_path__ + "img/30.f5a05550.jpg";